import { Fragment } from 'react';

import useLscOfferingInstanceOrgUnit from './UseLscOfferingInstanceOrgUnit';

import LscOfferingManagementContextLoadingModal from '../LscOfferingManagementContextLoadingModal';

import OfferingInstanceOrgUnitGrid from '../../components/grids/offeringInstanceOrgUnit/OfferingInstanceOrgUnitGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import ReportPeriodDropdown from '@usas/ui-web/components/dropdowns/reportPeriodDropdown/ReportPeriodDropdown';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

const LscOfferingInstanceOrgUnit = () => {
  const {
    organizationId,
    canAddAdditionalInstance,
    state,
    offeringManagementInstanceOrgUnitState,

    onReportPeriodChanged,
    onAddOfferingInstanceOrgUnitClicked,
    onEditOfferingInstanceOrgUnitClicked,
    onAddAdditionalOfferingInstanceOrgUnitClicked,
    onEditAdditionalOfferingInstanceOrgUnitClicked
  } = useLscOfferingInstanceOrgUnit();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>LSC Offerings</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-8 usas-extra-top-margin">
          <ActionIntraPageButton type="button" onClick={(e) => onAddOfferingInstanceOrgUnitClicked(e)}>
            Add Offering
          </ActionIntraPageButton>
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4 usas-extra-bottom-margin">
          {state.reportPeriodId > 0 &&
            <ReportPeriodDropdown
              label="Report Period"
              name="reportPeriodId"
              value={state.reportPeriodId}
              error={undefined}
              message={undefined}
              organizationId={organizationId}
              defaultOption={false}
              reverseDataOrder={true}
              currentAndFutureOptionsOnly={false}
              onChange={(newValue, newValueLabel, e) => {
                e && e.target && e.target.value && onReportPeriodChanged(newValue, newValueLabel);
              }} />
          }
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <OfferingInstanceOrgUnitGrid
            gridData={offeringManagementInstanceOrgUnitState.arrayData}
            isLoading={offeringManagementInstanceOrgUnitState.isArrayLoading}
            canAddAdditionalInstance={canAddAdditionalInstance === true}
            onEditInstance={onEditOfferingInstanceOrgUnitClicked}
            onAddAdditionalInstance={onAddAdditionalOfferingInstanceOrgUnitClicked}
            onEditAdditionalInstance={onEditAdditionalOfferingInstanceOrgUnitClicked} />
        </div>
      </div>
      <LscOfferingManagementContextLoadingModal
        isLoading={false}
        isError={state.pageErrorMessage !== ''}
        errorMessage={state.pageErrorMessage} />
    </Fragment>
  );
};

export default LscOfferingInstanceOrgUnit;